import { useAtomValue } from 'jotai';

import { TableSkeleton } from '@/lib/components';
import { Flex } from '@/lib/v2/components';

import { CampaignsTable } from '@/src/modules/CampaignsModule/components/Campaigns/CampaignsTable';

import { ActionBarButtons } from './components/ActionBarButtons';
import { FilterBar } from './components/FilterBar';

import {
  atomCampaignList,
  atomTotalSelectedRows,
  atomTotalsProcess,
} from '@/modules/CampaignsModule/atoms/campaignAtom';

export function TableContainer() {
  const campaignsList = useAtomValue(atomCampaignList);
  const totalCampaignsList = useAtomValue(atomTotalsProcess);
  const totalSelectedRows = useAtomValue(atomTotalSelectedRows);

  return (
    <Flex column>
      {campaignsList ? (
        <>
          {totalCampaignsList?.total > 0 && (
            <Flex alignment="start" className="mb-[16px]">
              {totalSelectedRows > 0 ? <ActionBarButtons /> : <FilterBar />}
            </Flex>
          )}
          <Flex column withGap itemAlignment="stretch">
            <CampaignsTable />
          </Flex>
        </>
      ) : (
        <div className="h-full w-full py-10">
          <TableSkeleton columns={7} />
        </div>
      )}
    </Flex>
  );
}
